/**
 * Confetti Hook
 * 紙吹雪エフェクトを管理するカスタムフック
 */

import { useState, useCallback, useEffect } from 'react';
import Confetti from 'react-confetti';

export const useConfetti = () => {
  const [isActive, setIsActive] = useState(false);
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const trigger = useCallback((duration = 5000) => {
    setIsActive(true);
    setTimeout(() => setIsActive(false), duration);
  }, []);

  const ConfettiComponent = isActive ? (
    <Confetti
      width={windowSize.width}
      height={windowSize.height}
      numberOfPieces={500}
      recycle={false}
      colors={['#3b82f6', '#14b8a6', '#8b5cf6', '#22d3ee', '#f59e0b', '#ef4444']}
      gravity={0.3}
    />
  ) : null;

  return { trigger, ConfettiComponent };
};
